import { render, staticRenderFns } from "./FoodNav.vue?vue&type=template&id=01c2b09f&scoped=true&"
import script from "./FoodNav.vue?vue&type=script&lang=js&"
export * from "./FoodNav.vue?vue&type=script&lang=js&"
import style0 from "./FoodNav.vue?vue&type=style&index=0&id=01c2b09f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c2b09f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShieldPicto: require('/opt/build/repo/components/ShieldPicto.vue').default})
